import VImg from './VImg.vue';

export { VImg };
export default VImg;
